import MoneyComponents from './Money.vue';

const money = {
    install:function(Vue) {
        Vue.component('money', MoneyComponents)
    }
}

export default money;